// @ts-nocheck
/* eslint-disable */
export const compareArrowsIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00671 9.3335H1.33337V10.6668H6.00671V12.6668L8.66671 10.0002L6.00671 7.3335V9.3335ZM9.99337 8.66683V6.66683H14.6667V5.3335H9.99337V3.3335L7.33337 6.00016L9.99337 8.66683Z" fill="currentColor"/></svg>`,
    name: 'compare-arrows' as const
};